import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_SEVERITY } from '@ddt-web/config';

import { PasModelFamiliesError, PopupDialogObject, PopupDialogOptions } from '../../models';
import { AbstractErrorHandlerService } from '../abstract-error-handler.service';
import { ErrorHelperService } from '../error-helper.service';
import { ErrorPopupService } from '../error-popup.service';



@Injectable()
export class PasModelFamiliesErrorHandlerService extends AbstractErrorHandlerService {
	constructor(
		public contentService: ContentService,
		public errorPopupService: ErrorPopupService,
		public tealiumAnalyticsService: TealiumAnalyticsService,
		public errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error: any): void {
		if (error instanceof PasModelFamiliesError) {
			this.trackErrorMessage = error.errorMessage;
			this.errorSeverity = error.errorSeverity;
			const disableClose = this.errorSeverity === ERROR_SEVERITY.CRITICAL || this.errorSeverity === ERROR_SEVERITY.ERROR;
			const dialogTitleDCRKey = disableClose ? 'PAS_MODEL_FAMILIES_ERROR_TITLE' : 'PAS_MODEL_FAMILIES_PARTIAL_ERROR_TITLE';
			const dialogDescriptionDCRKey = disableClose ? 'PAS_MODEL_FAMILIES_ERROR_DESCRIPTION' : 'PAS_MODEL_FAMILIES_PARTIAL_ERROR_DESCRIPTION';
			const failedMessage = PopupDialogObject.create({
				success: false,
				title: this.contentService.get(dialogTitleDCRKey, 'There is an error while loading the model families'),
				description: this.contentService.get(dialogDescriptionDCRKey, `${error.errorMessage}`),
				requestId: error.errorCode
			} as PopupDialogOptions);
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
			this.errorPopupService.openResponseMessageDialog(failedMessage, disableClose);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
